<script setup>
import { defineEmits, defineProps } from 'vue'
const props = defineProps({
  photoUrl: String,
  show: Boolean
})

const emits = defineEmits(['update:show', 'track'])

function throttle(fn, delay = 100) {
  let last = 0
  return (...args) => {
    const now = Date.now()
    if (now - last >= delay) {
      last = now
      fn(...args)
    }
  }
}

/**
 * 下载图片
 * */
const handleDownloadImage = throttle(async () => {
  emits('track', 'downloadPhoto', { content: props.photoUrl })

  const response = await fetch(props.photoUrl, {
    mode: 'cors'
  })
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = 'photo.jpg'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(blobUrl)
}, 200)

const handleClose = () => {
  emits('update:show', false)
}
</script>

<template>
  <div v-if="show" class="preview-photo-wrapper" @click="handleClose">
    <div class="content" @click.prevent.stop>
      <div class="imgWrapper">
        <img :src="photoUrl" alt="" />
      </div>
      <div class="rightTopIcon" @click="handleDownloadImage">
        <img src="../../assets/download.png" alt="" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.preview-photo-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .content {
    width: 311px;
    height: 487px;
    position: relative;

    .imgWrapper {
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .rightTopIcon {
      position: absolute;
      top: 7px;
      right: 7px;
      background: rgba(255, 255, 255, 0.6);
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
